import React, { useContext, useState, useEffect } from 'react';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import NotesIcon from '@material-ui/icons/Notes';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Collapse, List, Tooltip } from '@material-ui/core';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemText from '@mui/material/ListItemText';
import BlurLinearIcon from '@material-ui/icons/BlurLinear';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssessmentIcon from '@material-ui/icons/Assessment';
import EventNoteIcon from '@material-ui/icons/EventNote';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import TimelineIcon from '@material-ui/icons/Timeline';
import PersonIcon from '@material-ui/icons/Person';
import SettingsIcon from '@material-ui/icons/Settings';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import LayersIcon from '@material-ui/icons/Layers';
import TableChartIcon from '@material-ui/icons/TableChart';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AppContext from '../../../components/contextProvider/AppContextProvider/AppContext';
import CachedIcon from '@material-ui/icons/Cached';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { ThemeContext } from '../../../themes/ThemeProvider';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import SubjectIcon from '@material-ui/icons/Subject';
import AirplayOutlinedIcon from '@material-ui/icons/AirplayOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SettingsSystemDaydreamOutlinedIcon from '@material-ui/icons/SettingsSystemDaydreamOutlined';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import LookupIcon from '@material-ui/icons/FileCopyOutlined';
import BuildIcon from '@material-ui/icons/Build';
import { ReactComponent as AccountIcon } from '../../../assets/images/datacalculationIcon.svg';
import { ReactComponent as FilterIcon } from '../../../assets/images/filterruleIcon.svg';
import { ReactComponent as WorkQueueIcon } from '../../../assets/images/WorkQueueIcon.svg';
import { ReactComponent as AuditListIcon } from '../../../assets/images/auditListIcon.svg';
import { ReactComponent as ImportExecutionIcon } from '../../../assets/images/importExecution.svg';
import { ReactComponent as EmportExecutionIcon } from '../../../assets/images/exportExecution.svg';
import { ReactComponent as OrganizationIcon } from '../../../assets/images/organizationIcon.svg';
import { ReactComponent as LetterRequested } from '../../../assets/images/letterRequestedIcon.svg';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import ArrowRightAltOutlinedIcon from '@material-ui/icons/ArrowRightAltOutlined';
import { ReactComponent as SchedulerExecutionIcon } from '../../../assets/images/schedulerExecution.svg';
import { ReactComponent as TenantsIcon } from '../../../assets/images/tenants.svg';
// import { ReactComponent as TenantsIcon } from "../../../assets/images/tenantsIcon.svg";
import BackupIcon from '@material-ui/icons/Backup';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined';
import WorkQueueActivityIcon from '@material-ui/icons/DvrOutlined';
import { ReactComponent as Billicons } from '../../../assets/images/billicons.svg';
import { ReactComponent as Billingregistration } from '../../../assets/images/billingregistration.svg';

const CmtVertical = (props) => {
  const { roleData } = useSelector(({ role }) => role);
  const location = useLocation();
  const history = useHistory();
  const [schedule, setSchedule] = useState(false);
  const [windows1, setWindows1] = React.useState();
  const [letters, setOpenLetters] = React.useState();
  const [importManager, setImportManger] = useState(false);
  const [exportManager, setExportManager] = useState(false);
  const [businessRules, setBusinessRules] = useState(false);
  const [openEvents, setOpenEvents] = React.useState(false);
  const [operationsOpen, setOperationsOpen] = useState(false);
  const [administration, setAdministration] = useState(false);
  const [dataManagement, setDatamanagement] = useState(false);
  const [clientManagement, setClientManagement] = useState(false);
  const [dataRepositoryField, setDataRepositoryField] = useState(false);
  const [workQueuesField, setWorkQueuesField] = useState(false);
  const { sideNavSection } = useContext(ThemeContext);
  const [billingIndicator, setBillingIndicator] = useState(false);
  const { setSideNavAccNotes } = useContext(SelectTabContextProvider);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  const handleEventsClick = () => {
    setOpenEvents(!openEvents);
  };
  const handleAdminiStration = () => {
    setAdministration(!administration);
  };
  const handleBusinessRules = () => {
    setBusinessRules(!businessRules);
  };
  const handleClickOperations = () => {
    setOperationsOpen(!operationsOpen);
  };
  const handleDataClick = () => {
    setDatamanagement(!dataManagement);
  };
  const handleScheduler = () => {
    setSchedule(!schedule);
  };
  const handleClient = () => {
    setClientManagement(!clientManagement);
  };
  const handleBilling = () => {
    setBillingIndicator(!billingIndicator);
  };
  const handleLettersClick = () => {
    setOpenLetters(!letters);
  };
  const handleImportManagerClick = () => {
    setImportManger(!importManager);
  };
  const handleExportManagerClick = () => {
    setExportManager(!exportManager);
  };
  let windows;
  useEffect(() => {
    if (roleData) {
      const authorisedWindows = roleData?.window ? roleData['window'] : {};
      windows = Object.keys(authorisedWindows);
      setWindows1(windows);
    }
  }, [roleData]);

  const handleAccountNotes = async () => {
    location?.state?.batchName
      ? sessionStorage.setItem('batchName', location?.state?.batchName)
      : sessionStorage.removeItem('batchName');
    if (history.location.pathname !== '/account-summary') {
      await history.push({
        pathname: `/account-summary`,
        state: {
          accountNumber: location?.state?.accountNumber ? location?.state?.accountNumber : '',
          batchName: location?.state?.batchName ? location?.state?.batchName : '',
          accountData: location?.state?.accountData ? location.state.accountData : [],
        },
      });
    }
    await setSideNavAccNotes(true);
  };
  const [accountNotes, setAccountNotes] = useState(false);
  useEffect(() => {
    if (
      roleData &&
      Object.keys(roleData) &&
      roleData?.window &&
      roleData?.window?.['Core Windows']
    ) {
      setAccountNotes(Object.keys(roleData?.window?.['Core Windows']).includes('W32'));
    }
  }, [roleData]);
  const { setSideBarStatus } = useContext(AppContext);
  return (
    <div onMouseEnter={() => setSideBarStatus(true)} onMouseLeave={() => setSideBarStatus(false)}>
      <div className="sidenav">
        <ul>
          {accountNotes && windows1.includes('Core Windows') && (
            <li
              className={location.pathname === `/account-summary` ? 'active' : ''}
              onClick={() => handleAccountNotes()}
            >
              <Tooltip title={`${sideNavSection ? '' : 'Account Summary'}`}>
                <NotesIcon />
              </Tooltip>
              <span>Account Summary</span>
            </li>
          )}
          {(roleData?.window?.['Letter Maintenance']?.LM ||
            roleData?.window?.['Letter Maintenance']?.LR ||
            roleData?.window?.['Letter Maintenance']?.LB) &&
            windows1?.includes('Letters') && (
            <li className="collapse-list-item">
              <ListItemButton
                onClick={handleLettersClick}
                className="navListBtn framework-list sublist-align"
              >
                <ListItemIcon className="sublist-icon">
                  <Tooltip title={`${sideNavSection ? '' : 'Letters'}`}>
                    <TableChartIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary="Letters" />
                {letters ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
              </ListItemButton>
            </li>
          )}
          <Collapse in={letters} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {roleData?.window?.['Letter Maintenance']?.LM?.read && (
                <li className="collapse-list-item">
                  <ListItemButton
                    className={
                      location.pathname === `/letters/letter-maintenance`
                        ? 'sublist active-state'
                        : 'sublist'
                    }
                    onClick={() =>
                      history.push({
                        pathname: `/letters/letter-maintenance`,
                        state: {
                          accountNumber: location?.state?.accountNumber
                            ? location?.state?.accountNumber
                            : '',
                          batchName: location?.state?.batchName ? location?.state?.batchName : '',
                          accountData: location?.state?.accountData
                            ? location.state.accountData
                            : [],
                        },
                      })
                    }
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Letter Maintenance'}`}>
                        <AssignmentIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Letter Maintenance" />
                  </ListItemButton>
                </li>
              )}
              {roleData?.window?.['Letter Maintenance']?.LR?.read && (
                <li className="collapse-list-item">
                  <ListItemButton
                    className={
                      location.pathname === `/letters/letter-request`
                        ? 'sublist active-state data-calculation-list'
                        : 'sublist data-calculation-list'
                    }
                    onClick={() =>
                      history.push({
                        pathname: '/letters/letter-request',
                        state: {
                          accountNumber: location?.state?.accountNumber
                            ? location?.state?.accountNumber
                            : '',
                          batchName: location?.state?.batchName ? location?.state?.batchName : '',
                          accountData: location?.state?.accountData
                            ? location.state.accountData
                            : [],
                        },
                      })
                    }
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Letters Requested'}`}>
                        <LetterRequested className="data-calculation-icon" />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Letters Requested" />
                  </ListItemButton>
                </li>
              )}
              {roleData?.window?.['Letter Maintenance']?.LB?.read && (
                <li className="collapse-list-item">
                  <ListItemButton
                    className={
                      location.pathname === `/letters/letter-batches`
                        ? 'sublist active-state'
                        : 'sublist'
                    }
                    onClick={() =>
                      history.push({
                        pathname: '/letters/letter-batches',
                        state: {
                          accountNumber: location?.state?.accountNumber
                            ? location?.state?.accountNumber
                            : '',
                          batchName: location?.state?.batchName ? location?.state?.batchName : '',
                          accountData: location?.state?.accountData
                            ? location.state.accountData
                            : [],
                        },
                      })
                    }
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Letter Batches'}`}>
                        <LayersIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Letter Batches" />
                  </ListItemButton>
                </li>
              )}
            </List>
          </Collapse>
          {windows1?.includes('Client Management') && (
            <ListItemButton
              onClick={handleClient}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon main-list-icons">
                <Tooltip title={`${sideNavSection ? '' : 'Client Management'}`}>
                  <div>
                    <ScheduleIcon className="scheduler-icon" />
                  </div>
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Client Management" />
              {clientManagement ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}

          <Collapse in={clientManagement} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {roleData?.window?.['Client Management']?.CLMGM && (
                <ListItemButton
                  className={
                    location.pathname === `/client-organization`
                      ? 'sublist active-state data-calculation-list'
                      : 'sublist data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/client-organization`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'Client Maintenance'}`}>
                      <div>
                        <OrganizationIcon className="data-calculation-icon" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Client Maintenance" />
                </ListItemButton>
              )}
              {roleData?.window?.['Client Management']?.TE && (
                <ListItemButton
                  className={
                    location.pathname === `/client-tenants`
                      ? 'sublist active-state data-calculation-list'
                      : 'sublist data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/client-tenants`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'Tenants'}`}>
                      <div>
                        <TenantsIcon className="data-calculation-icon" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Tenants" />
                </ListItemButton>
              )}
            </List>
          </Collapse>

          {windows1?.includes('Billing Indicator') && (
            <ListItemButton
              onClick={handleBilling}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon main-list-icons">
                <Tooltip title={`${sideNavSection ? '' : 'Billing Indicator'}`}>
                  <div style={{ fontSize: '1.2rem' }}>
                    <Billicons className="data-calculation-icon" />
                  </div>
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Billing Indicator" />
              {billingIndicator ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}

          <Collapse in={billingIndicator} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {roleData?.window?.['Billing Indicator']?.BIM && (
                <ListItemButton
                  className={
                    location.pathname === `/billing-indicator-maintenance`
                      ? 'sublist active-state data-calculation-list'
                      : 'sublist data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/billing-indicator-maintenance`,
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'Billing Indicator Maintenance'}`}>
                      <div style={{ fontSize: '1.4rem' }}>
                        <Billingregistration className="data-calculation-icon" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText
                    className={`${sideNavSection ? 'billing' : ''}`}
                    primary="Billing Indicator Maintenance"
                  />
                </ListItemButton>
              )}
            </List>
          </Collapse>
          {(windows1?.includes('Data Repository') ||
            windows1?.includes('Client Audit Field List') ||
            windows1?.includes('Imports') ||
            windows1?.includes('Exports') ||
            windows1?.includes('Reporting/Export')) &&
            windows1?.includes('Data Management') && (
            <ListItemButton
              onClick={handleDataClick}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon main-list-icons">
                <Tooltip title={`${sideNavSection ? '' : 'Data Management'}`}>
                  <div>
                    <AirplayOutlinedIcon />
                    <BarChartOutlinedIcon className="sub-list-secondary" />
                  </div>
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Data Management" />
              {dataManagement ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}
          <Collapse in={dataManagement} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {windows1?.includes('Data Repository') && (
                <ListItemButton
                  className={
                    location.pathname === `/frameworks/data-repository`
                      ? 'sublist active-state'
                      : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/data-repository`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Data Repository'}`}>
                      <SettingsSystemDaydreamOutlinedIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Data Repository" />
                  {dataRepositoryField ? (
                    <ExpandLess
                      color="inherit"
                      onClick={() => {
                        setDataRepositoryField(false);
                      }}
                    />
                  ) : (
                    <ExpandMore
                      color="inherit"
                      onClick={() => {
                        setDataRepositoryField(true);
                      }}
                    />
                  )}
                </ListItemButton>
              )}
              <Collapse in={dataRepositoryField} timeout="auto" unmountOnExit>
                <li className="collapse-list-item">
                  <ListItemButton
                    className={
                      location.pathname === `/frameworks/data-repository/repository-fields`
                        ? 'event-sublist active-state'
                        : 'event-sublist'
                    }
                    onClick={() => {
                      history.push({
                        pathname: `/frameworks/data-repository/repository-fields`,
                        state: {
                          tabValue: 1,
                        },
                      });
                    }}
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Repository Fields '}`}>
                        <LayersOutlinedIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Repository Fields" />
                  </ListItemButton>
                </li>
              </Collapse>
              {windows1?.includes('Staging Repository') && (
                <ListItemButton
                  className={
                    location.pathname === `/frameworks/staging-repository`
                      ? 'sublist active-state'
                      : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/staging-repository`,
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Staging Repository'}`}>
                      <LayersOutlinedIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Staging Repository" />
                </ListItemButton>
              )}
              {windows1?.includes('Audit Field List') && (
                <ListItemButton
                  className={
                    location.pathname === `/frameworks/audit-field-list`
                      ? 'sublist active-state data-calculation-list'
                      : 'sublist data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/audit-field-list`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Audit Field List'}`}>
                      <AuditListIcon className="data-calculation-icon" />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Audit Field List" />
                </ListItemButton>
              )}
              {windows1?.includes('Client Audit Field List') && (
                <ListItemButton
                  className={
                    location.pathname === `/frameworks/client-audit-field-list`
                      ? 'sublist active-state'
                      : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/client-audit-field-list`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Client Audit Field List'}`}>
                      <AccountTreeIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Client Audit Field List" />
                </ListItemButton>
              )}
              {windows1?.includes('Reporting/Export') && (
                <li className="collapse-list-item">
                  <ListItemButton
                    className={
                      location.pathname === `/frameworks/reports`
                        ? 'sublist active-state'
                        : 'sublist'
                    }
                    onClick={() => {
                      history.push({
                        pathname: `/frameworks/reports`,
                        state: {
                          accountNumber: location?.state?.accountNumber
                            ? location?.state?.accountNumber
                            : '',
                          batchName: location?.state?.batchName ? location?.state?.batchName : '',
                          accountData: location?.state?.accountData
                            ? location.state.accountData
                            : [],
                        },
                      });
                    }}
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Reporting/Export'}`}>
                        <AssessmentIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Reporting/Export" />
                  </ListItemButton>
                </li>
              )}
              {(roleData?.window?.['Imports']?.ITMPR ||
                roleData?.window?.['Imports']?.IRG ||
                roleData?.window?.['Imports']?.IM ||
                roleData?.window?.['Imports']?.IEH) &&
                roleData?.window?.['Imports']?.ID && (
                <li className="collapse-list-item">
                  <ListItemButton
                    onClick={handleImportManagerClick}
                    className="navListBtn framework-list"
                  >
                    <ListItemIcon className="sublist-icon ETsublist">
                      <Tooltip title={`${sideNavSection ? '' : 'Imports'}`}>
                        <SystemUpdateAltIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Imports" />
                    {importManager ? (
                      <ExpandLess color="inherit" />
                    ) : (
                      <ExpandMore color="inherit" />
                    )}
                  </ListItemButton>
                </li>
              )}
              <Collapse in={importManager} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {roleData?.window?.['Imports']?.ITMPR ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/import-template-record`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/import-template-record`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon main-list-icons">
                          <Tooltip title={`${sideNavSection ? '' : 'Template Records'}`}>
                            <div>
                              <InsertDriveFileOutlinedIcon />
                              <ArrowRightAltOutlinedIcon className="import-manager-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Template Records" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Imports']?.IRG ? (
                    <li
                      className={`${
                        sideNavSection ? 'collapse-list-item manager-record' : 'collapse-list-item '
                      }`}
                    >
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/import-record-group`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/import-record-group`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon  main-list-icons">
                          <Tooltip title={`${sideNavSection ? '' : 'Record Groups'}`}>
                            <div>
                              <FileCopyOutlinedIcon />
                              <ArrowRightAltOutlinedIcon className="import-manager-record-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Record Groups" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Imports']?.IM ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/import-manager`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/import-manager`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Import Manager'}`}>
                            <CloudDownloadIcon />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Import Manager" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Imports']?.IEH ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/dm-import-execution-history`
                            ? 'event-sublist active-state  data-calculation-list'
                            : 'event-sublist  data-calculation-list'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/dm-import-execution-history`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Execution History'}`}>
                            <ImportExecutionIcon className="data-calculation-icon" />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Execution History" />
                      </ListItemButton>
                    </li>
                  ) : null}
                </List>
              </Collapse>
              {(roleData?.window?.['Exports']?.ETMPR ||
                roleData?.window?.['Exports']?.ERG ||
                roleData?.window?.['Exports']?.EM ||
                roleData?.window?.['Exports']?.EEH) &&
                roleData?.window?.['Exports']?.ED && (
                <li className="collapse-list-item">
                  <ListItemButton
                    onClick={handleExportManagerClick}
                    className="navListBtn framework-list"
                  >
                    <ListItemIcon className="sublist-icon ETsublist">
                      <Tooltip title={`${sideNavSection ? '' : 'Exports'}`}>
                        <SystemUpdateAltIcon className="export-icon" />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Exports" />
                    {exportManager ? (
                      <ExpandLess color="inherit" />
                    ) : (
                      <ExpandMore color="inherit" />
                    )}
                  </ListItemButton>
                </li>
              )}
              <Collapse in={exportManager} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {roleData?.window?.['Exports']?.ETMPR ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/export-template-record`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/export-template-record`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon main-list-icons">
                          <Tooltip title={`${sideNavSection ? '' : 'Template Records'}`}>
                            <div>
                              <InsertDriveFileOutlinedIcon />
                              <ArrowRightAltOutlinedIcon className="export-manager-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Template Records" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Exports']?.ERG ? (
                    <li
                      className={`${
                        sideNavSection ? 'collapse-list-item manager-record' : 'collapse-list-item '
                      }`}
                    >
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/export-record-group`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/export-record-group`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon main-list-icons">
                          <Tooltip title={`${sideNavSection ? '' : 'Record Groups'}`}>
                            <div>
                              <FileCopyOutlinedIcon />
                              <ArrowRightAltOutlinedIcon className="export-manager-record-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Record Groups" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Exports']?.EM ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/export-manager`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/export-manager`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Export Manager'}`}>
                            <BackupIcon />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Export Manager" />
                      </ListItemButton>
                    </li>
                  ) : null}
                  {roleData?.window?.['Exports']?.EEH ? (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/dm-export-execution-history`
                            ? 'event-sublist active-state  data-calculation-list'
                            : 'event-sublist data-calculation-list'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/dm-export-execution-history`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Execution History'}`}>
                            <EmportExecutionIcon className="data-calculation-icon" />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Execution History" />
                      </ListItemButton>
                    </li>
                  ) : null}
                </List>
              </Collapse>
            </List>
          </Collapse>
          {(windows1?.includes('Data Calculations') ||
            windows1?.includes('Filter Rules') ||
            windows1?.includes('Triggers Maintenance') ||
            windows1?.includes('Account Update') ||
            windows1?.includes('Batch Triggers') ||
            windows1?.includes('Event Triggers')) &&
            windows1?.includes('Business Rules') && (
            <ListItemButton
              onClick={handleBusinessRules}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon ">
                <Tooltip title={`${sideNavSection ? '' : 'Business Rules'}`}>
                  <BusinessOutlinedIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Business Rules" />
              {businessRules ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}
          <Collapse in={businessRules} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {windows1?.includes('Data Calculations') && (
                <ListItemButton
                  className={
                    location.pathname === `/frameworks/data-calculation`
                      ? 'sublist active-state  data-calculation-list'
                      : 'sublist  data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/data-calculation`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Data Calculations'}`}>
                      <AccountIcon className="data-calculation-icon" />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Data Calculations" />
                </ListItemButton>
              )}
              {windows1?.includes('Filter Rules') && (
                <ListItemButton
                  className={
                    location.pathname === '/frameworks/filter-rules'
                      ? 'sublist active-state data-calculation-list'
                      : 'sublist data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/frameworks/filter-rules`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Filter Rules'}`}>
                      <FilterIcon className="data-calculation-icon" />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Filter Rules" />
                </ListItemButton>
              )}
              {(windows1?.includes('Triggers Maintenance') ||
                windows1?.includes('Account Update') ||
                windows1?.includes('Batch Triggers') ||
                windows1?.includes('Event Triggers')) && (
                <li className="collapse-list-item">
                  <ListItemButton
                    className="navListBtn framework-list "
                    onClick={handleEventsClick}
                  >
                    <ListItemIcon className="sublist-icon  ETsublist">
                      <Tooltip title={`${sideNavSection ? '' : 'Triggers'}`}>
                        <EventNoteIcon />
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Triggers" />
                    {openEvents ? <ExpandLess color="white" /> : <ExpandMore color="white" />}
                  </ListItemButton>
                </li>
              )}
              <Collapse in={openEvents} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {windows1?.includes('Triggers Maintenance') && (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/event-tactics/triggers`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/event-tactics/triggers`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Trigger Maintenance'}`}>
                            <TimelineIcon />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Trigger Maintenance" />
                      </ListItemButton>
                    </li>
                  )}
                  {windows1?.includes('Batch Triggers') && (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/event-tactics/trigger-group`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/event-tactics/trigger-group`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <Tooltip title={`${sideNavSection ? '' : 'Batch Triggers'}`}>
                            <FlashOnIcon />
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Batch Triggers" />
                      </ListItemButton>
                    </li>
                  )}
                  {windows1?.includes('Event Triggers') && (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/event-tactics/event-trigger-group`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/event-tactics/event-trigger-group`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon">
                          <div className="relativeUserIcon">
                            <span className="triggerEventIcon">
                              <Tooltip title={`${sideNavSection ? '' : 'Event Triggers'}`}>
                                <CalendarTodayIcon />
                              </Tooltip>
                            </span>
                            <span className="triggerTimelineIcon">
                              <Tooltip title={`${sideNavSection ? '' : 'Event Triggers'}`}>
                                <TimelineIcon />
                              </Tooltip>
                            </span>
                          </div>
                        </ListItemIcon>
                        <ListItemText primary="Event Triggers" />
                      </ListItemButton>
                    </li>
                  )}
                  {windows1?.includes('Account Update') && (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/event-tactics/account-update-group`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/event-tactics/account-update-group`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon trigger-sublist-icon">
                          <div className="relativeUserIcon">
                            <span className="triggerAccountIcon">
                              <Tooltip title={`${sideNavSection ? '' : 'Account Update '}`}>
                                <CachedIcon />
                              </Tooltip>
                            </span>
                            <span className="triggeruserIcon">
                              <Tooltip title={`${sideNavSection ? '' : 'Account Update '}`}>
                                <PersonIcon />
                              </Tooltip>
                            </span>
                          </div>
                        </ListItemIcon>
                        <ListItemText primary="Account Update " />
                      </ListItemButton>
                    </li>
                  )}
                </List>
              </Collapse>
            </List>
          </Collapse>

          {/* Menu Item for Works Queue. Top Nav */}
          {windows1?.includes('Work Queue') && (
            <ListItemButton
              onClick={() => {
                setWorkQueuesField(!workQueuesField);
              }}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon">
                <Tooltip title={`${sideNavSection ? '' : 'Work Queues'}`}>
                  <WorkQueueIcon className="data-calculation-icon work-queue-icon" />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Work Queues" />
              {workQueuesField ? (
                <ExpandLess
                  color="inherit"
                  onClick={() => {
                    setWorkQueuesField(false);
                  }}
                />
              ) : (
                <ExpandMore
                  color="inherit"
                  onClick={() => {
                    setWorkQueuesField(true);
                  }}
                />
              )}
            </ListItemButton>
          )}
          <Collapse in={workQueuesField} timeout="auto" unmountOnExit>
            <li className="collapse-list-item">
              <ListItemButton
                className={
                  location.pathname === `/work-queue`
                    ? 'event-sublist active-state'
                    : 'event-sublist'
                }
                onClick={() => {
                  history.push({
                    pathname: `/work-queue`,
                  });
                }}
              >
                <ListItemIcon className="sublist-icon">
                  <Tooltip title={`${sideNavSection ? '' : 'Assigned '}`}>
                    <LayersOutlinedIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary="Assigned" />
              </ListItemButton>
            </li>
            <li className="collapse-list-item">
              <ListItemButton
                className={
                  location.pathname === `/work-queue/owned`
                    ? 'event-sublist active-state'
                    : 'event-sublist'
                }
                onClick={() => {
                  history.push({
                    pathname: `/work-queue/owned`,
                    state: {
                      tabValue: 1,
                    },
                  });
                }}
              >
                <ListItemIcon className="sublist-icon">
                  <Tooltip title={`${sideNavSection ? '' : 'Owned '}`}>
                    <LayersOutlinedIcon />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText primary="Owned" />
              </ListItemButton>
            </li>
          </Collapse>
          {/* End Menu Item for Works Queue */}

          {(windows1?.includes('Work Queue Setup') ||
            windows1?.includes('New Business Maintenance') ||
            windows1?.includes('Add Account') ||
            windows1?.includes('Scheduler')) &&
            windows1?.includes('Operations') && (
            <ListItemButton
              onClick={handleClickOperations}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon main-list-icons">
                <Tooltip title={`${sideNavSection ? '' : 'Operations'}`}>
                  <div>
                    <AutorenewOutlinedIcon />
                    <SettingsIcon className="sub-list-secondary settings-operation-icon" />
                  </div>
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Operations" />
              {operationsOpen ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}
          <Collapse in={operationsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {windows1?.includes('Work Queue Setup') && (
                <>
                  <ListItemButton
                    className={
                      location.pathname === `/work-queue-setup`
                        ? 'sublist active-state  data-calculation-list'
                        : 'sublist  data-calculation-list'
                    }
                    onClick={() => {
                      history.push({
                        pathname: `/work-queue-setup`,
                        state: {
                          accountNumber: location?.state?.accountNumber
                            ? location?.state?.accountNumber
                            : '',
                          batchName: location?.state?.batchName ? location?.state?.batchName : '',
                          accountData: location?.state?.accountData
                            ? location.state.accountData
                            : [],
                        },
                      });
                    }}
                  >
                    <ListItemIcon className="sublist-icon">
                      <Tooltip title={`${sideNavSection ? '' : 'Work Queue Setup'}`}>
                        <div className="main-list-icons">
                          <SubjectIcon />
                          <SettingsIcon className="settings-icon" />
                        </div>
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Work Queue Setup" />
                  </ListItemButton>
                </>
              )}
              {windows1?.includes('Work Queue Activity') && (
                <ListItemButton
                  className={
                    location.pathname === `/work-queue-activity`
                      ? 'sublist active-state  data-calculation-list'
                      : 'sublist  data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/work-queue-activity`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Work Queue Activity'}`}>
                      <div className="main-list-icons">
                        <WorkQueueActivityIcon />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Work Queue Activity" />
                </ListItemButton>
              )}

              {/* New Business. Second Level Nav */}
              {windows1?.includes('New Business Maintenance') && (
                <ListItemButton
                  className={
                    location.pathname === `/new-business`
                      ? 'sublist active-state  data-calculation-list'
                      : 'sublist  data-calculation-list'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/new-business`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'New Business'}`}>
                      <div className="main-list-icons">
                        <BusinessCenterIcon />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="New Business" />
                </ListItemButton>
              )}
              {/* End New Business. Second Level Nav */}

              {windows1?.includes('Add Account') && (
                <ListItemButton
                  className={
                    location.pathname === `/new-business-maintenance/add-account`
                      ? 'sublist active-state'
                      : 'sublist'
                  }
                  onClick={() =>
                    history.push({
                      pathname: '/new-business-maintenance/add-account',
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    })
                  }
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Add Account'}`}>
                      <PersonAddIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Add Account" />
                </ListItemButton>
              )}
              {(roleData?.window?.['Scheduler']?.SC || roleData?.window?.['Scheduler']?.EH) &&
                windows1?.includes('Scheduler') && (
                <li className="collapse-list-item">
                  <ListItemButton
                    onClick={handleScheduler}
                    className="navListBtn framework-list data-calculation-list"
                  >
                    <ListItemIcon className="sublist-icon ETsublist  main-list-icons">
                      <Tooltip title={`${sideNavSection ? '' : 'Scheduler'}`}>
                        <div className="main-list-icons">
                          <CalendarTodayIcon />
                          <ScheduleIcon
                            className={`${
                                sideNavSection ? `scheduler-main-list` : `scheduler-icon`
                              }`}
                          />
                        </div>
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary="Scheduler" />
                    {schedule ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
                  </ListItemButton>
                </li>
              )}
              <Collapse in={schedule} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {roleData?.window?.['Scheduler']?.SC && (
                    <li className="collapse-list-item">
                      <ListItemButton
                        className={
                          location.pathname === `/frameworks/scheduler`
                            ? 'event-sublist active-state'
                            : 'event-sublist'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/frameworks/scheduler`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon main-list-icons ">
                          <Tooltip title={`${sideNavSection ? '' : 'Scheduler'}`}>
                            <div className="main-list-icons">
                              <CalendarTodayIcon />
                              <ScheduleIcon className="scheduler-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Scheduler" />
                      </ListItemButton>
                    </li>
                  )}
                  {roleData?.window?.['Scheduler']?.EH && (
                    <li
                      className={`${
                        sideNavSection ? `collapse-list-item manager-record` : `collapse-list-item`
                      }`}
                    >
                      <ListItemButton
                        className={
                          location.pathname === `/scheduler-execution-history`
                            ? 'event-sublist active-state data-calculation-list'
                            : 'event-sublist data-calculation-list'
                        }
                        onClick={() => {
                          history.push({
                            pathname: `/scheduler-execution-history`,
                            state: {
                              accountNumber: location?.state?.accountNumber
                                ? location?.state?.accountNumber
                                : '',
                              batchName: location?.state?.batchName
                                ? location?.state?.batchName
                                : '',
                              accountData: location?.state?.accountData
                                ? location.state.accountData
                                : [],
                            },
                          });
                        }}
                      >
                        <ListItemIcon className="sublist-icon main-list-icons">
                          <Tooltip title={`${sideNavSection ? '' : 'Execution History'}`}>
                            <div>
                              <SchedulerExecutionIcon className="data-calculation-icon" />
                            </div>
                          </Tooltip>
                        </ListItemIcon>
                        <ListItemText primary="Execution History" />
                      </ListItemButton>
                    </li>
                  )}
                </List>
              </Collapse>
            </List>
          </Collapse>
          {(windows1?.includes('Role Management') ||
            windows1?.includes('User Management') ||
            windows1?.includes('Lookup Maintenance') ||
            windows1?.includes('Translation Tables') ||
            windows1?.includes('Custom Window Setup')) &&
            windows1?.includes('Administration') && (
            <ListItemButton
              onClick={handleAdminiStration}
              className="navListBtn text-nowrap framework-list sublist-align"
            >
              <ListItemIcon className="sublist-icon main-list-icons">
                <Tooltip title={`${sideNavSection ? '' : 'Administration'}`}>
                  <div>
                    <AirplayOutlinedIcon />
                    <SettingsIcon className="sub-list-secondary" />
                  </div>
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Administration" />
              {administration ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </ListItemButton>
          )}

          <Collapse in={administration} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {windows1?.includes('Lookup Maintenance') && (
                <ListItemButton
                  className={
                    location.pathname === `/lookup-maintenance` ? 'sublist active-state' : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/lookup-maintenance`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons lookup-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Lookup Maintenance'}`}>
                      <div>
                        <LookupIcon className="lookup1" />
                        <SettingsIcon className="sub-list-secondary lookup2" />
                        <BuildIcon className="sublist-secondary-position lookup3" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Lookup Maintenance" />
                </ListItemButton>
              )}
              {windows1?.includes('Role Management') && (
                <ListItemButton
                  className={
                    location.pathname === `/role-management` ? 'sublist active-state' : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/role-management`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'Role Management'}`}>
                      <div>
                        <PersonIcon />
                        <VpnKeyIcon className="sublist-secondary-position" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Role Management" />
                </ListItemButton>
              )}
              {windows1?.includes('User Management') && (
                <ListItemButton
                  className={
                    location.pathname === `/user-management` ? 'sublist active-state' : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/user-management`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'User Management'}`}>
                      <div>
                        <PersonIcon />
                        <SettingsIcon className="sublist-secondary-position" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="User Management" />
                </ListItemButton>
              )}
              {windows1?.includes('Custom Window Setup') && (
                <ListItemButton
                  className={
                    location.pathname === `/custom-window` ? 'sublist active-state' : 'sublist'
                  }
                  onClick={() =>
                    history.push({
                      pathname: `/custom-window`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    })
                  }
                >
                  <ListItemIcon className="sublist-icon">
                    <Tooltip title={`${sideNavSection ? '' : 'Custom Windows'}`}>
                      <BlurLinearIcon />
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Custom Windows" />
                </ListItemButton>
              )}
              {windows1?.includes('Translation Tables') && (
                <ListItemButton
                  className={
                    location.pathname === `/translation-table` ? 'sublist active-state' : 'sublist'
                  }
                  onClick={() => {
                    history.push({
                      pathname: `/translation-table`,
                      state: {
                        accountNumber: location?.state?.accountNumber
                          ? location?.state?.accountNumber
                          : '',
                        batchName: location?.state?.batchName ? location?.state?.batchName : '',
                        accountData: location?.state?.accountData ? location.state.accountData : [],
                      },
                    });
                  }}
                >
                  <ListItemIcon className="sublist-icon main-list-icons">
                    <Tooltip title={`${sideNavSection ? '' : 'Translation Table'}`}>
                      <div>
                        <PersonIcon />
                        <SettingsIcon className="sublist-secondary-position" />
                      </div>
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary="Translation Table" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </ul>
      </div>
    </div>
  );
};

export default CmtVertical;
